import React from 'react';
import { Content } from './Content.js';
import postTypes from './postTypes.js';
import moment from "moment";
import { ReactComponent as ThoughtLeadershipIcon } from '../../icons/svg/lightbulb.svg';
import { ReactComponent as IndustryEventsIcon } from '../../icons/svg/event.svg';
import { ReactComponent as CaseStudiesIcon } from '../../icons/svg/case_study.svg';
import { ReactComponent as CompanyHighlightsIcon } from '../../icons/svg/NRG-N.svg';
import { ReactComponent as NewsIcon } from '../../icons/svg/megaphone.svg';
import { ReactComponent as ArrowLeftIcon } from '../../icons/svg/ic-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../icons/svg/ic-right.svg';
import Slider from "react-slick";
import SecurityCheckForm from '../SecurityCheckForm/SecurityCheckForm.jsx';
import { getNewsData } from '../../utils/contentfulData/contentfulData.js';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export default class StyledButtonPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      enteriesItemsList: [],
      enteriesItemsListFeatured: [],
      enteriesItemsListFiltered: [],
      enteriesItemsListFullPageArticles: [],
      activeFilterList: [],
      oldSlide: 0,
      activeSlide: 0,
      activeSlide2: 0,
      enteriesShownInList: 9,
      isDevSecurityCheckOpen: false
    }

    this.settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (current, next) =>
        this.setState({ oldSlide: current, activeSlide: next }),
      afterChange: current => this.setState({ activeSlide2: current })
    };

    this.isDevContent = false;
    this.username = '';
    this.password = '';

    this.carouselSlider = React.createRef();
  }
  componentWillUnmount() {
    this.props.onRef(undefined);
  }
  checkIfDevMode() {
    if (window.location.pathname.indexOf("/news/dev") == 0) {
      this.isDevContent = true;
      this.openSecurityCheck();
    }
  }
  componentDidMount() {
    this.props.onRef(this);

    this.checkIfDevMode();

    this.loadInContentFromContentful();
  }
  loadInContentFromContentful() {
    // if (!this.isDevContent || (this.isDevContent && this.username != '')) {
      getNewsData(this.isDevContent, this.username, this.password)
        .then((entries) => {
          if (entries && entries.items && entries.items.length > 0) {
            let tempEnteriesListFeatured = [];
            let tempEnteriesListFullPageArticles = [];
            let tempEnteriesList = [];
            for (let i = 0; i < entries.items.length; i++) {
              let tempItem = entries.items[i];
              if (tempItem.fields.postTitle) {
                tempItem.momentDate = moment(tempItem.fields.postDate);
                tempItem.formattedDate = tempItem.momentDate.format("MMM D, YYYY");;
                tempItem.id = tempItem.sys.id;
                tempEnteriesList.push(tempItem);
                if (tempItem.fields.isPostFeatured) {
                  tempEnteriesListFeatured.push(tempItem);
                }
                if (tempItem.fields.isFullPageArticle) {
                  tempEnteriesListFullPageArticles.push(tempItem);
                }
              }
            }

            tempEnteriesListFeatured = tempEnteriesListFeatured.sort((left, right) => {
              return left.fields.featuredOrderValue - right.fields.featuredOrderValue;
            })

            tempEnteriesList = tempEnteriesList.sort((left, right) => {
              return right.momentDate.diff(left.momentDate);
            })

            this.setState({
              enteriesItemsList: tempEnteriesList, enteriesItemsListFiltered: tempEnteriesList,
              enteriesItemsListFeatured: tempEnteriesListFeatured, enteriesItemsListFullPageArticles: tempEnteriesListFullPageArticles,
              enteriesShownInList: 9
            }, () => {
              this.attemptToOpenPost();
            });
          }
        })
        .catch((err) => {
          console.log("err");
          console.log(err);
        })
    // }
  }
  attemptToOpenPost() {
    let urlPrefix = this.isDevContent ? "/news/dev/" : "/news/";

    for (let i = 0; i < this.state.enteriesItemsList.length; i++) {
      // first check is for production, the second is for draft posts, with dev prefix
      if (window.location.pathname === urlPrefix + this.state.enteriesItemsList[i].fields.postTitle.replace(/\s+/g, '-').toLowerCase()
        || window.location.pathname === urlPrefix + this.state.enteriesItemsList[i].fields.postTitle.replace(/\s+/g, '%20')) {
        this.openPost(this.state.enteriesItemsList[i]);
      }
    }
  }
  openSecurityCheck() {
    if (this.isDevContent) {
      // check for username and password before getting content from contentful
      this.setState({ isDevSecurityCheckOpen: true });
    }
  }
  openPageAfterSecurityCheck(username, password) {
    this.setState({ isDevSecurityCheckOpen: false });
    this.username = username;
    this.password = password;

    this.loadInContentFromContentful();
  }
  filterPosts = (filterType) => {
    let filterTypeList = this.state.activeFilterList;

    if (filterTypeList.includes(filterType)) {
      filterTypeList.splice(filterTypeList.indexOf(filterType), 1);
    } else {
      filterTypeList.push(filterType);
    }

    if (filterTypeList && filterTypeList.length > 0) {
      let tempFilteredPostList = [];
      for (let i = 0; i < this.state.enteriesItemsList.length; i++) {
        if (filterTypeList.includes(this.state.enteriesItemsList[i].fields.postType)) {
          tempFilteredPostList.push(this.state.enteriesItemsList[i]);
        }
      }

      this.setState({ activeFilterList: filterTypeList, enteriesItemsListFiltered: tempFilteredPostList, enteriesShownInList: 9 });
    } else {
      this.setState({ activeFilterList: [], enteriesItemsListFiltered: this.state.enteriesItemsList, enteriesShownInList: 9 });
    }
  }
  isFilterSelected(postTypeConstant) {
    return this.state.activeFilterList.includes(postTypeConstant);
  }
  loadInIcon = (postType) => {
    switch (postType) {
      case postTypes.ThoughtLeadership:
        return <span className="icon-container icon-thought-leadership"><ThoughtLeadershipIcon></ThoughtLeadershipIcon></span>;
        break;
      case postTypes.IndustryEvents:
        return <span className="icon-container"><IndustryEventsIcon></IndustryEventsIcon></span>;
        break;
      case postTypes.CaseStudies:
        return <span className="icon-container"><CaseStudiesIcon></CaseStudiesIcon></span>;
        break;
      case postTypes.CompanyHighlights:
        return <span className="icon-container icon-custom-padding-top icon-container-company-highlights"><CompanyHighlightsIcon></CompanyHighlightsIcon></span>;
        break;
      case postTypes.Press:
        return <span className="icon-container icon-container-press"><NewsIcon></NewsIcon></span>;
        break;
      default:
        return null;
    }
  }
  openPost = (postObj) => {
    if (postObj.fields.postUrl && !postObj.fields.isFullPageArticle) {
      window.open(postObj.fields.postUrl, '_blank');
    } else {
      let postIndex = 0;
      for (let i = 0; i < this.state.enteriesItemsListFullPageArticles.length; i++) {
        if (this.state.enteriesItemsListFullPageArticles[i].id === postObj.id) {
          postIndex = i;
          i = this.state.enteriesItemsListFullPageArticles.length;
        }
      }

      let tempPostObj = postObj;
      if (this.state.enteriesItemsListFullPageArticles.length > 1) {

        // get next article
        if (postIndex == this.state.enteriesItemsListFullPageArticles.length - 1) {
          tempPostObj.nextArticleText = this.state.enteriesItemsListFullPageArticles[0].fields.postTitle;
        } else {
          tempPostObj.nextArticleText = this.state.enteriesItemsListFullPageArticles[postIndex + 1].fields.postTitle;
        }

        // get prior article
        if (postIndex == 0) {
          tempPostObj.priorArticleText = this.state.enteriesItemsListFullPageArticles[this.state.enteriesItemsListFullPageArticles.length - 1].fields.postTitle;
        } else {
          tempPostObj.priorArticleText = this.state.enteriesItemsListFullPageArticles[postIndex - 1].fields.postTitle;
        }
      }
      tempPostObj.currentIndex = postIndex;
      this.props.openPost(tempPostObj);
    }
  }
  loadInPreviousArticle(postIndex) {
    if (postIndex == 0) {
      this.openPost(this.state.enteriesItemsListFullPageArticles[this.state.enteriesItemsListFullPageArticles.length - 1]);
    } else {
      this.openPost(this.state.enteriesItemsListFullPageArticles[postIndex - 1]);
    }
  }
  loadInNextArticle(postIndex) {
    if (postIndex == this.state.enteriesItemsListFullPageArticles.length - 1) {
      this.openPost(this.state.enteriesItemsListFullPageArticles[0], 0);
    } else {
      this.openPost(this.state.enteriesItemsListFullPageArticles[postIndex + 1]);
    }
  }
  loadMore = () => {
    if (this.state.enteriesShownInList < this.state.enteriesItemsListFiltered.length) {
      this.setState((prevState) => { return { enteriesShownInList: prevState.enteriesShownInList + 9 } });
    }
  }
  securityCheck() {
    return <div>
      <SecurityCheckForm passedSecurityCheck={(username, password) => this.openPageAfterSecurityCheck(username, password)}></SecurityCheckForm>
    </div>
  }
  render() {
    return (
      <React.Fragment>
        {this.state.isDevSecurityCheckOpen && <div>
          {this.securityCheck()}
        </div>}
        <div className={`StyledButtonPanel row`}>
          <div className="featured-section-container">
            <div className="UnderPipePanel">
              <div className="stroke vertical left"></div>
              <div className="stroke vertical right"></div>
              <div className="main-content">
                <div className="col-xs-16">
                  <div>
                    <Slider ref={ref => (this.carouselSlider = ref)} {...this.settings}>
                      {this.state.enteriesItemsListFeatured.map((item, itemIndex) => {
                        return <div key={item.id} className="featured-article-container">
                          <div onClick={() => this.openPost(item)} className="featured-article-section article-image col-lg-8">
                            <img className="featured-post-image" src={item.fields.postImage.fields.file.url + "?h=1000&q=70"} alt={"featured post"} />
                          </div>
                          {item.fields.postType && <div className={["featured-post-icon-type-container"].join(" ")}>
                            {this.loadInIcon(item.fields.postType)}
                          </div>}
                          {/* {item.postBase.fields.postType && <div className={["featured-post-icon-type-container", this.state.activeSlide2 == itemIndex ? 'show-icon' : 'hide-icon'].join(" ")}>
                          {this.loadInIcon(item.postBase.fields.postType)}
                        </div>} */}
                          <div className="featured-article-section bottom-section col-lg-8">
                            {this.state.enteriesItemsListFeatured.length > 1 && <div className="featured-post-direction-container">
                              <div className="featured-post-direction-arrow" onClick={() => this.carouselSlider.slickPrev()}><ArrowLeftIcon></ArrowLeftIcon></div>
                              <div className="featured-post-direction-arrow" onClick={() => this.carouselSlider.slickNext()}><ArrowRightIcon></ArrowRightIcon></div>
                            </div>}
                            <div className="featured-post-date">{item.formattedDate}</div>
                            <div onClick={() => this.openPost(item)} className="featured-post-description-text">
                              {item.fields.postTitle}
                            </div>
                          </div>
                        </div>
                      })}
                    </Slider>

                    {/* {this.state.enteriesItemsList.map((item) => {
                    return <React.Fragment>
                      <div key={item.id} className="featured-article-container">
                        <img className="featured-post-image" src={item.postBase.fields.postImage.fields.file.url} alt={"featured post"} />
                        {item.postBase.fields.postType && <div className="featured-post-icon-type-container">
                          {this.loadInIcon(item.postBase.fields.postType)}
                        </div>}
                        <div className="featured-post-date">{item.formattedDate}</div>
                        <div className="featured-post-description-text">{item.postBase.fields.postTitle}</div>
                        }
                      </div>
                    </React.Fragment> */}

                    {/* 
                      <React.Fragment><div className="col-lg-5" key={item.id}>
                        <div className="post-container" onClick={() => this.openPost(item)}>
                          <div>
                            {item.postBase.fields.postImage && <div className="post-image-container">
                              <img className="post-image" src={item.postBase.fields.postImage.fields.file.url} alt={"post"} />
                              <div className="post-image-cover"></div>
                            </div>}
                            <div className="post-description-container-outside">
                              <div className="post-description-container-inner">
                                {item.postBase.fields.postType && <div className="post-icon-type-container">
                                  {this.loadInIcon(item.postBase.fields.postType)}
                                </div>
                                }
                                <div className="post-date">{item.formattedDate}</div>
                                <div className="post-description-text">{item.postBase.fields.postTitle}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        {divider}
                      </React.Fragment> */}

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <div className={`IconListPanel row remove-margin-on-side`}>
              <div className="col-xs-16">
                <div className="fake-void left"></div>
                <div className="fake-void right"></div>
                <div className="inner">
                </div>
                <div className="stroke vertical left"></div>
                <div className="stroke vertical right"></div>
              </div>
            </div>
          </div>

          <div className={`IconListPanel`}>
            <div className="col-xs-16">
              <div className="fake-void left"></div>
              <div className="fake-void right"></div>
              <div className="inner">
                <div className="row list-panel-row">
                  <div className="icon-selection-container">
                    <div className="title">Sharing Knowledge</div>
                    <div className="sub-title">Filter by content type</div>
                    <div className="icon-list-container">
                      <div className={["col-lg-4", "thought-leadership-icon", this.isFilterSelected(postTypes.ThoughtLeadership) ? 'selected-post-type' : ''].join(' ')}
                        onClick={() => this.filterPosts(postTypes.ThoughtLeadership)}>
                        <span><span className="icon-container icon-thought-leadership"><ThoughtLeadershipIcon /></span><span className="post-type-text">Thought Leadership</span></span>
                      </div>
                      <div className={["col-lg-4", "industry-events", this.isFilterSelected(postTypes.IndustryEvents) ? 'selected-post-type' : ''].join(' ')}
                        onClick={() => this.filterPosts(postTypes.IndustryEvents)}>
                        <span><span className="icon-container"><IndustryEventsIcon /></span><span className="post-type-text">Industry Events</span></span>
                      </div>
                      {/* <div className={["col-lg-3", "case-studies-icon", this.isFilterSelected(postTypes.CaseStudies) ? 'selected-post-type' : ''].join(' ')}
                        onClick={() => this.filterPosts(postTypes.CaseStudies)}>
                        <span><span   className="icon-container"><CaseStudiesIcon /></span><span className="post-type-text">Case Studies</span></span>
                      </div> */}
                      <div className={["col-lg-4", "company-highlights-icon", this.isFilterSelected(postTypes.CompanyHighlights) ? 'selected-post-type' : ''].join(' ')}
                        onClick={() => this.filterPosts(postTypes.CompanyHighlights)}>
                        <span><span className="icon-container icon-custom-padding-top icon-container-company-highlights"><CompanyHighlightsIcon /></span><span className="post-type-text">Company Highlights</span></span>
                      </div>
                      <div className={["col-lg-4", "news-icon", this.isFilterSelected(postTypes.Press) ? 'selected-post-type' : ''].join(' ')}
                        onClick={() => this.filterPosts(postTypes.Press)}>
                        <span><span className="icon-container icon-container-press"><NewsIcon /></span><span className="post-type-text">Press</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stroke vertical left"></div>
              <div className="stroke vertical right"></div>
            </div>
          </div>
          <div className="posts-list-panel UnderPipePanel">
            <div className="stroke vertical left"></div>
            <div className="stroke vertical right"></div>
            <div className="main-content">
              <div className="col-xs-16">
                <div className="posts-list-container row">
                  {this.state.enteriesItemsListFiltered.map((item, itemIndex) => {
                    return <React.Fragment key={item.id}>{itemIndex < this.state.enteriesShownInList && <div className="col-lg-5">
                      <div className="post-container" onClick={() => this.openPost(item)}>
                        <div>
                          {item.fields.postImage && item.fields.postImage.fields.file && item.fields.postImage.fields.file.url && <div className="post-image-container">
                            <img className="post-image" src={item.fields.postImage.fields.file.url + "?h=600&q=70"} alt={"post"} />
                            <div className="post-image-cover"></div>
                          </div>}
                          <div className="post-description-container-outside">
                            <div className="post-description-container-inner">
                              {item.fields.postType && <div className="post-icon-type-container">
                                {this.loadInIcon(item.fields.postType)}
                              </div>
                              }
                              
                              {item.fields.articleLogo && item.fields.articleLogo.fields && item.fields.articleLogo.fields.logo && 
                                item.fields.articleLogo.fields.logo.fields && item.fields.articleLogo.fields.logo.fields.file && item.fields.articleLogo.fields.logo.fields.file.url &&
                                <React.Fragment>
                                  <div className="post-logo-reference post-logo-reference-img"><img src={item.fields.articleLogo.fields.logo.fields.file.url} /></div>
                                </React.Fragment>
                              }
                              <div className="post-date">{item.formattedDate}</div>
                              <div className="post-description-text">{item.fields.postTitle}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                    </React.Fragment>
                  })}
                </div>
                {this.state.enteriesShownInList < this.state.enteriesItemsListFiltered.length && <div className="posts-list-load-more-container">
                  <button onClick={() => this.loadMore()}>Discover More</button>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

};
